import { appendCustomTextResponse } from "../../../store/conversation.tsx";
import { SignUpState } from "../../../store/types.tsx";
import { updateSignUpState } from "../../../store/auth.tsx";
import axios from "../../../utils/axios.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

const handleAgreeToDataProtectionAgreement = async (
  trimmedText: string,
  dispatch: any,
  signUpState: SignUpState,
) => {
  // This function proceeds as follows:
  // 1. Check if the user has entered 'Agree'.
  // 2. If the user has not entered 'Agree', prompt them to do so.
  // 3. If the user has entered 'Agree', create a new account on the server.
  // 4. If the account is created successfully, append a success message.
  if (
    trimmedText.toLowerCase() !==
    i18n
      ._(
        msg({
          message: "Agree",
          context:
            "Command issued by the user to accept data protection policy.",
        }),
      )
      .toLowerCase()
  ) {
    return dispatch(
      appendCustomTextResponse(
        i18n._(
          msg({
            message:
              "To confirm that you agree to our data protection policy, please type 'Agree'.",
            context:
              "Message instructing the user on how to agree to the data protection policy.",
          }),
        ),
      ),
    );
  }

  const signUpResponse = await signUp(signUpState);
  if (!signUpResponse) {
    return dispatch(
      appendCustomTextResponse(
        i18n._(
          msg({
            message: "Error creating your account.",
            context:
              " Message informing the user that the account creation process encountered an error.",
          }),
        ),
      ),
    );
  }

  dispatch(
    appendCustomTextResponse(
      i18n._(
        msg({
          message: `Thank you, your account was successfully created! 🥳. 
       I look forward to helping you with all of your financial reporting needs. I will now log you in so we can start
       so I can better understand you and your data.`,
          context:
            "Message congratulating the user for the successful account creation.",
        }),
      ),
    ),
  );
  dispatch(updateSignUpState({ isComplete: true }));

  setTimeout(() => {
    const token = signUpResponse.data.token;
    const url = signUpResponse.data.url;
    localStorage.setItem("token", token);
    window.location.href = url;
  }, 3000);
};

const signUp = async (signUpState: SignUpState) => {
  try {
    const signUpResponse = await axios.post("/v1/anonymous/signup/", {
      sign_up_token: signUpState.signUpToken,
      terms_and_conditions_hash: signUpState.termsAndConditionsHash,
      data_protection_policy_hash: signUpState.dataProtectionPolicyHash,
    });
    if (signUpResponse.status !== 200) {
      return null;
    }
    return signUpResponse;
  } catch (error) {
    return null;
  }
};

export default handleAgreeToDataProtectionAgreement;
